import React from "react";
import { MyReferralCode } from "../../../DataModels/DataModels";
import ActiveShareCard from "./ActiveShareCard";
import CardList from "./CardList";

interface ActiveShareListProps {
	referrals: MyReferralCode[];
	isLoading: boolean;
	onCopyLink: (code: string) => void;
	onRevoke: (code: string) => void;
	maxHeight?: string;
}

const SkeletonCards: React.FC = () => (
	<div className="space-y-2 animate-pulse">
		{[1, 2, 3].map((i) => (
			<div
				key={i}
				className="bg-primary-accent border border-primary-inactive rounded-lg p-3"
			>
				<div className="flex items-center gap-3">
					<div className="h-5 w-5 bg-primary-inactive rounded-full flex-shrink-0" />
					<div className="flex-grow space-y-2">
						<div className="h-4 bg-primary-inactive rounded w-40" />
						<div className="h-3 bg-primary-inactive rounded w-56" />
					</div>
					<div className="h-4 w-12 bg-primary-inactive rounded-full flex-shrink-0" />
				</div>
				<div className="flex gap-3 mt-2 ml-8">
					<div className="h-3 bg-primary-inactive rounded w-14" />
					<div className="h-3 bg-primary-inactive rounded w-12" />
				</div>
			</div>
		))}
	</div>
);

const ActiveShareList: React.FC<ActiveShareListProps> = ({
	referrals,
	isLoading,
	onCopyLink,
	onRevoke,
	maxHeight
}) => {
	return (
		<div>
			<p className="ml-1 text-primary-active text-sm font-semibold mb-2">
				Active Shares
			</p>
			{isLoading ? (
				<SkeletonCards />
			) : referrals.length === 0 ? (
				<div className="flex flex-col items-center justify-center text-primary p-4 border rounded-2xl border-primary-inactive border-dashed">
					<p className="text-sm">No active shares yet. Invite a friend</p>
					<p className="text-sm">to get started!</p>
				</div>
			) : (
				<CardList className={maxHeight ?? ""}>
					{referrals.map((ref) => (
						<ActiveShareCard
							key={ref.code}
							referral={ref}
							onCopyLink={onCopyLink}
							onRevoke={onRevoke}
						/>
					))}
				</CardList>
			)}
		</div>
	);
};

ActiveShareList.displayName = "ActiveShareList";

export default ActiveShareList;
export type { ActiveShareListProps };
